import React from 'react'

const AddSloat = () => {
    return (
        <div>
            <h1>add sloat</h1>
        </div>
    )
}

export default AddSloat
